import { render, staticRenderFns } from "./simple-vue-calendar.vue?vue&type=template&id=a20c769e&scoped=true"
import script from "./simple-vue-calendar.vue?vue&type=script&lang=js"
export * from "./simple-vue-calendar.vue?vue&type=script&lang=js"
import style0 from "./simple-vue-calendar.vue?vue&type=style&index=0&id=a20c769e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20c769e",
  null
  
)

export default component.exports